import { arrow1 } from '../../../../common/back/lace/arrow'
import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wp4Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 模様左側
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(584, 127, 606, 179)
  ctx.quadraticCurveTo(492, 216, 492, 216)
  ctx.quadraticCurveTo(498, 189, 507, 170) //
  ctx.quadraticCurveTo(560, 155, 560, 155) //
  ctx.quadraticCurveTo(535, 110, 535, 110) //
  ctx.quadraticCurveTo(549, 81, 549, 81) //

  // 模様右下
  ctx.moveTo(509, 304) //左下
  ctx.quadraticCurveTo(616, 224, 616, 224) // 中央
  ctx.quadraticCurveTo(628, 284, 622, 334)
  ctx.quadraticCurveTo(597, 352, 597, 352)
  ctx.quadraticCurveTo(600, 317, 597, 284) //
  ctx.quadraticCurveTo(543, 341, 543, 341) //
  ctx.quadraticCurveTo(523, 326, 509, 304) //

  // 模様右上
  ctx.moveTo(624, 143)
  ctx.quadraticCurveTo(661, 234, 664, 304) //
  ctx.stroke()
  ctx.closePath()

  // 模様 'レース左下'
  ctx.beginPath()
  ctx.moveTo(485, 261) // 左下
  ctx.quadraticCurveTo(602, 207, 602, 207) // 右上
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //

  // 模様上の描画＿左側
  ctx.moveTo(547, 85) // 左上
  ctx.quadraticCurveTo(582, 132, 602, 177)
  ctx.quadraticCurveTo(497, 211, 497, 211)
  ctx.quadraticCurveTo(500, 189, 510, 172) //
  ctx.quadraticCurveTo(565, 157, 565, 157) //
  ctx.quadraticCurveTo(539, 108, 539, 108) //

  // 模様右下の描画＿
  ctx.moveTo(512, 306) //左下
  ctx.quadraticCurveTo(616, 228, 614, 228) // 中央
  ctx.quadraticCurveTo(625, 290, 619, 334)
  ctx.quadraticCurveTo(600, 347, 600, 347)
  ctx.quadraticCurveTo(601, 317, 599, 278) //
  ctx.quadraticCurveTo(541, 341, 541, 335) //

  // 模様右上
  ctx.moveTo(628, 145)
  ctx.quadraticCurveTo(665, 236, 667, 300) //

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  arrow1(ctx, laceColor, 29, -25, 0, 1)
  arrow1(ctx, laceColor, -42, -36, 0, 1.1)
  arrow1(ctx, laceColor, -105, -45, 0, 1.2)
  arrow1(ctx, laceColor, -160, -50, 0, 1.3)
  webKnots(ctx, laceColor, 10, 90, 1, 0.8) // ウェブ先端寄りのウェブ結び目
}
